import { useDispatch, useSelector } from 'react-redux'
import { SubscriptionsSelectors, SubscriptionsSlice } from './subscription-plans.slice'

export const SubscriptionsHooks = {
  useIsOpen: () => useSelector(SubscriptionsSelectors.getIsOpen),

  useSubscriptionsActions: () => {
    const dispatch = useDispatch()

    return {
      open: () => {
        // eslint-disable-next-line no-console
        console.log('open')
        dispatch(SubscriptionsSlice.actions.open())
      },
      close: () => {
        dispatch(SubscriptionsSlice.actions.close())
      },
    }
  },
}
